<template lang="pug">
    v-card
        //v-dialog.ma-5(
            ref="dialogDateBook"
            v-model="modal"
            :return-value.sync="date"
            lazy
            full-width
            width="290px"
            )
            v-text-field(
                slot="activator"
                v-model="date"
                label="Indique Período"
                prepend-icon="event"
                readonly
                )
            v-date-picker(v-model="date" type="month" scrollable locale)
            v-spacer
            v-btn(flat color="primary" @click="modal = false") Cancel
            v-btn(flat color="primary" @click="submitDate") OK
        model-data-table(
            :service="service"
            :headers="headers"
            @remove="submitDelete($event.item.id)"
            no-detail
            ref="refDTPchSaleBook"
            :filters="filters"
            :initial-filter-values="initialFilterValues"
            no-search
            remind-key='purchase-sale-book-list'
            :no-remove="!$can('DELETE_PURCHASE_SALE_BOOK')"
            )
            div(slot='actions' slot-scope="props")
                v-tooltip(bottom )
                    v-btn(
                        @click="submitDownloadExcel( props.item )"
                        slot="activator"
                        color="info"
                        icon
                        flat
                        v-if="$can('VIEW_DETAIL_PURCHASE_SALE_BOOK')"
                        )
                        v-icon file_download
                    span Descarga Excel
                v-tooltip(bottom )
                    v-btn(
                        @click="submitCheckDocument( props.item )"
                        slot="activator"
                        color="blue"
                        icon
                        flat
                        v-if="!props.item.reviewed_at && $can('EXECUTE_REVIEW_PURCHASE_SALE_BOOK')"
                        )
                        v-icon find_in_page
                    span Revisión
        crud-create-button(
            :action="submitGeneratePchSaleBookExcel"
            text="Generar Libro Compra Venta"
            v-if="$can('CREATE_PURCHASE_SALE_BOOK')"
            )
        dialog-create-pch-sale-book(ref="refDialogCreatePchSaleBook" @success="refreshPchSaleBookDT")
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { CrudCreateButton } from '@/components/reusable_components'
import ModelDataTable from '@/components/reusable_components/next/ModelDataTable'
import HeadersPchSaleBooks from './HeadersPchSaleBook'
import {
    deletePurchaseSaleBook,
    generatePchSaleBookExcel,
    reviewPurchaseSaleBook,
} from '@/services/api/purchaseSaleBook'
import DialogPchSaleBook from './dialog/DialogGeneratePchSaleBook'
import AccPurchaseSaleBook from '../../models/Accounting/AccPurchaseSaleBook'
import filters from './filters'

export default {
    name: 'list-pch-sale-book',
    // props: {},
    data: function() {
        return {
            service: AccPurchaseSaleBook,
            headers: HeadersPchSaleBooks,
            date: null,
            menu: false,
            modal: false,
            deleteId: 0,
            selectedItem: {},
            filters,
            initialFilterValues: {
                year: new Date().getFullYear(),
                month: new Date().getUTCMonth() + 1,
            },
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        // -- UI Modification
        submitDate: function() {
            this.$refs.dialogDateBook.save(this.date)
            this.data = this.$refs.dialogDateBook.$options.propsData.returnValue
            this.getPurchaseSaleBook(this.data)
        },
        submitGeneratePchSaleBookExcel: function() {
            this.$refs.refDialogCreatePchSaleBook.open = true
        },
        submitDelete: function(event) {
            //-
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Eliminar')
            //-
            let payload = this.fillSnack(
                'warning',
                '¿Desea eliminar libro de compra y venta?',
                ''
            )
            this.initSnackbar(payload)
            //-
            this.deleteId = event
        },
        submitCheckDocument: function(event) {
            //-
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Revisado')
            //-
            let payload = this.fillSnack(
                'info',
                '¿Ha realizado la revisión del libro de compra y venta?',
                ''
            )
            this.initSnackbar(payload)
            //-
            this.selectedItem = event
        },
        submitDownloadExcel: function(event) {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Descargar')
            let payload = this.fillSnack(
                'info',
                '¿Descargar detalle de compra y venta?',
                ''
            )
            this.initSnackbar(payload)
            this.selectedItem = event
        },
        // -- Data fetching
        getPurchaseSaleBook: function(date) {
            const includes = [
                'g_user.hr_employee',
                'g_reviewer_user.hr_employee',
            ]
            const year = date.substr(0, 4)
            const month = date.substr(5, 2)
            const url = process.env.VUE_APP_API_ROUTE.concat(
                `/acc_purchase_sale_book?filter[year]=${year}&filter[month]=${month}`
            )
            /* this.service.dtFetchData = DTService.getFetchDataFunction( */
            /* url, */
            /* includes, */
            /* [] */
            /* ) */
        },
        // -- Data handling and transformations
        refreshPchSaleBookDT: function() {
            this.$refs.refDTPchSaleBook.refresh()
        },
        // -- Validations and Error handling
        // -- Other functions
        getDateToday: function() {
            var moment = require('moment')
            const today = moment().format('YYYY-MM')
            this.date = today
        },
        // -- Vuex mappings
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        async responseConfirm(val) {
            //-
            if (val === 'Eliminar') {
                this.resetSnackbarState()
                let response = await deletePurchaseSaleBook(this.deleteId)
                //-
                if (response.status == 'success') {
                    let payload = this.fillSnack(
                        'success',
                        'Libro de compra y venta eliminado',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.$refs.refDTPchSaleBook.refresh()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
            if (val === 'Revisado') {
                this.resetSnackbarState()
                let response = await reviewPurchaseSaleBook(
                    this.selectedItem.id
                )
                //-
                if (response.status == 'success') {
                    let payload = this.fillSnack(
                        'success',
                        'Libro de compra y venta eliminado con éxito',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.$refs.refDTPchSaleBook.refresh()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
            if (val === 'Descargar') {
                this.resetSnackbarState()
                let response = await generatePchSaleBookExcel(
                    this.selectedItem.id
                )
                const url = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `${this.selectedItem.code}.xlsx`)
                document.body.appendChild(link)
                link.click()
                //-
                if (response.status == 200) {
                    let payload = this.fillSnack(
                        'success',
                        'Descarga correcta',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.$refs.refDTPchSaleBook.refresh()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'model-data-table': ModelDataTable,
        'crud-create-button': CrudCreateButton,
        'dialog-create-pch-sale-book': DialogPchSaleBook,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    mounted: function() {
        this.setTitleTopBar('Libro de compra y venta')
        this.getDateToday()
        this.getPurchaseSaleBook(this.date)
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_PURCHASE_SALE_BOOK')) ctx.$router.push('/')
        })
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>
